type NotificationLike = { type?: string | null; entity_type?: string | null };

export function notificationTarget(item: NotificationLike) {
  const type = String(item.type || "");
  if (item.entity_type === "customer_order_request" || type === "customer_order_request") return "operations";
  if (type === "service_completed") return "serviceQuality";
  if (item.entity_type === "order" || type.includes("order") || type.includes("dispatch") || type.includes("service_")) return type.includes("dispatch") ? "scheduling" : "operations";
  if (item.entity_type === "after_sale" || type.includes("after_sales") || type.includes("risk")) return "serviceQuality";
  if (type.includes("leave")) return "leaveApproval";
  // 系统不提供主动离职申请，离职审批页已下线；离职类通知只进消息中心，不再跳转死地址。
  if (item.entity_type === "worker_offboarding" || type.includes("offboarding")) return "communicationsCenter";
  if (type.includes("approval")) return "orderPayments";
  return "communicationsCenter";
}
